module.exports = __webpack_public_path__ + "img/saas.6f43f6a4.png";